import { useContext, useLayoutEffect, useState } from 'react';
import styled from 'styled-components';
import { Loader } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import { classnamePrefix } from '../../../../constants';
import { DataWithCache } from '../../../api';
import { processSource } from '../../../helpers';
import { sourceContext } from '../../../SourceContext';
import { HeaderContent } from './HeaderContent';

export const Header = () => {
  const { videosSource } = useContext(sourceContext);
  const [{ source, type }, setSource] = useState(
    processSource({ source: videosSource })
  );
  const { textColor, sort } = useSettings();

  useLayoutEffect(() => {
    setSource(processSource({ source: videosSource }));
  }, [videosSource]);

  return (
    <>
      {source && type !== 'videos' && (
        <DataWithCache
          sourceName={source}
          sourceType=""
          dataType="object"
          params={{ sort }}
        >
          {({ data, loading }) =>
            data && !loading ? (
              <HeaderContent type={type} data={data} />
            ) : (
              <SpinnerWrapper>
                <Loader
                  color={textColor}
                  size={40}
                  className={`${classnamePrefix}-spinner-component`}
                />
              </SpinnerWrapper>
            )
          }
        </DataWithCache>
      )}
    </>
  );
};

const SpinnerWrapper = styled.div.attrs({
  className: `${classnamePrefix}-header-spinner`
})`
  margin: 12px auto;
`;
